import React, { Component } from 'react';
import { Section, Row, Col, Paragraph, SmallText, TinyText } from '../';
import PropTypes from 'prop-types';

const clickText =
  typeof window !== 'undefined' &&
  ('ontouchstart' in window || window.DocumentTouch ? 'Tap' : 'Click');

export const SectionTitle = Section.extend`
  height: 125px;
  a {
    text-decoration: underline;
    color: white;

    &:hover {
      text-decoration: none;
      color: white;
    }
  }
`;

export const SectionOffer = Section.extend`
  cursor: pointer;
  width: 360px;
  border-bottom: 1px solid #ececec;
  height: 140px;
  text-align: center;
  padding: 0 10px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  .mid-bg {
    position: absolute;
    z-index: 1;
    background: white;
    box-shadow: 0 2px 8px 0 rgba(218, 203, 203, 0.7);
    border-radius: 6px;
    width: 100%;
    height: 160px;
    top: -10px;
    left: 0;
    padding: 2px;

    .cover {
      position: relative;
      padding-top: 10px;
      top: 0;
      border-radius: 6px;
    }

    &.selected {
      z-index: 3;
    }
  }
  .mid-offer {
    position: relative;
    z-index: 2;
  }
  p {
    margin-top: 0;
    margin-bottom: 0;
  }
  .title-1 {
    color: ${props => props.theme.primary};
    margin-top: 6px;
    font-size: 18px;
  }
  .title-2 {
    margin-top: 8px;
  }
  .title-5 {
    color: ${props => props.theme.secondary};
    font-size: 18px;
    margin-top: 0;
  }
  .title-6 {
    color: ${props => props.theme.muted};
    margin-top: 2px;
    font-size: 10px;
  }

  @media (max-width: 360px) {
    padding: 0 5px;
    width: 300px;
    .mid-bg {
      width: 102%;
      left: -1px;
    }
  }

  .cover {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 2px;
    left: 0;
    background: ${props => props.theme.primary};
    color: white;

    .cover-title-1 {
      margin-top: 30px;
    }
    .cover-title-2 {
      font-size: 18px;
      margin-top: 20px;
    }
  }
`;

export const MidCol = Col.extend`
  position: relative;

  .title-1 {
    margin-top: 4px;
  }
  .title-2 {
    margin-top: 10px;
  }
  .title-5 {
    margin-top: 2px;
  }
  .title-6 {
    margin-top: 5px;
  }
`;

export const ThanksButton = Paragraph.extend`
  margin-top: 18px;
  margin-bottom: 0;
  cursor: pointer;
  color: ${props => props.theme.muted};
`;

export default class LeadPackUpsellOffer extends Component {
  static propTypes = {
    gaCategory: PropTypes.string,
    loading: PropTypes.bool,
    submitPurchaseOffer: PropTypes.func,
    declineOffer: PropTypes.func,
    selectOffer: PropTypes.func,
    contactName: PropTypes.string,
    checksum: PropTypes.string,
    jobInvitationId: PropTypes.number,
    data: PropTypes.object,
    coin: PropTypes.string,
    siteSource: PropTypes.string
  };

  constructor() {
    super();

    this.state = {
      selectedOfferIndex: -1
    };
  }

  selectOffer = index => {
    this.setState({
      selectedOfferIndex: index
    });

    this.props.selectOffer(index);
  };

  confirmOffer = index => {
    const { jobInvitationId, submitPurchaseOffer, checksum, loading } = this.props;

    if (loading) {
      return;
    }

    submitPurchaseOffer(jobInvitationId, checksum, index);
  };

  render() {
    const { contactName, data, declineOffer, gaCategory, coin, siteSource } = this.props;
    const { offers } = data;
    const { selectedOfferIndex } = this.state;

    return (
      <div style={{ minHeight: siteSource === 'decline-offer' ? 322 : 362 }}>
        {contactName && (
          <Paragraph style={{ marginTop: 10 }} center>
            You&apos;re now connected with {contactName}
          </Paragraph>
        )}
        <SectionTitle primary gradient>
          <Row style={{ width: '100%' }}>
            <Col xs={3.6} style={{ paddingTop: 33, textAlign: 'center' }}>
              <img width={56} height={56} src={coin} alt="coin" />
            </Col>
            <Col xs={8.4} style={{ paddingTop: 10 }}>
              <p style={{ marginBottom: 0, fontSize: 18 }}>SPECIAL OFFER</p>
              {siteSource === 'decline-offer' ? (
                <SmallText style={{ marginBottom: 0 }}>
                  Get a discount on leads with a lead pack
                </SmallText>
              ) : (
                <SmallText style={{ marginBottom: 0 }}>
                  Save up to{' '}
                  {Math.max(
                    offers[0].discount_percentage,
                    offers[1].discount_percentage,
                    offers[2].discount_percentage
                  )}% on this lead
                </SmallText>
              )}
              <TinyText style={{ marginBottom: 0, marginTop: 5 }}>
                <a
                  href="/content/lead_pack_upsell_terms_conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-ga-category={gaCategory}
                  data-ga-action="View Terms and Conditions"
                  data-ga-label="View Terms and Conditions"
                  data-ga-property={data.tier_name}
                >
                  View Terms and Conditions
                </a>
              </TinyText>
            </Col>
          </Row>
        </SectionTitle>
        <SectionOffer>
          <Row>
            <Col style={{ position: 'relative' }} xs={4}>
              <div
                onClick={() => {
                  this.selectOffer(0);
                }}
              >
                <p className="title-1">Bonus {offers[0].discount_percentage}%</p>
                <p className="title-2">${offers[0].price}</p>
                <TinyText className="title-3">Lead Pack</TinyText>
                <TinyText className="title-4">for</TinyText>
                <p className="title-5">${offers[0].discounted_price}</p>
                <p className="title-6">Expires in {offers[0].expiry_period_days} days</p>
              </div>
              {selectedOfferIndex === 0 && (
                <div
                  className="cover"
                  onClick={() => {
                    this.confirmOffer(0);
                  }}
                >
                  <TinyText className="cover-title-1">{clickText} to confirm purchase</TinyText>
                  <p className="cover-title-2">${offers[0].discounted_price}</p>
                </div>
              )}
            </Col>
            <MidCol style={{ position: 'relative' }} xs={4}>
              <div className={`mid-bg ${selectedOfferIndex === 1 ? 'selected' : ''}`}>
                {selectedOfferIndex === 1 && (
                  <div
                    className="cover"
                    onClick={() => {
                      this.confirmOffer(1);
                    }}
                  >
                    <TinyText className="cover-title-1">{clickText} to confirm purchase</TinyText>
                    <p className="cover-title-2">${offers[1].discounted_price}</p>
                  </div>
                )}
              </div>
              <div
                className="mid-offer"
                onClick={() => {
                  this.selectOffer(1);
                }}
              >
                <p className="title-1">Bonus {offers[1].discount_percentage}%</p>
                <p className="title-2">${offers[1].price}</p>
                <TinyText className="title-3">Lead Pack</TinyText>
                <TinyText className="title-4">for</TinyText>
                <p className="title-5">${offers[1].discounted_price}</p>
                <p className="title-6">Expires in {offers[1].expiry_period_days} days</p>
              </div>
            </MidCol>
            <Col style={{ position: 'relative' }} xs={4}>
              <div
                onClick={() => {
                  this.selectOffer(2);
                }}
              >
                <p className="title-1">Bonus {offers[2].discount_percentage}%</p>
                <p className="title-2">${offers[2].price}</p>
                <TinyText className="title-3">Lead Pack</TinyText>
                <TinyText className="title-4">for</TinyText>
                <p className="title-5">${offers[2].discounted_price}</p>
                <p className="title-6">Expires in {offers[2].expiry_period_days} days</p>
              </div>
              {selectedOfferIndex === 2 && (
                <div
                  className="cover"
                  onClick={() => {
                    this.confirmOffer(2);
                  }}
                >
                  <TinyText className="cover-title-1">{clickText} to confirm purchase</TinyText>
                  <p className="cover-title-2">${offers[2].discounted_price}</p>
                </div>
              )}
            </Col>
          </Row>
        </SectionOffer>
        <ThanksButton center onClick={declineOffer}>
          No thanks
        </ThanksButton>
      </div>
    );
  }
}
